var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(-5006 -21296)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 24,
    height: 24,
    transform: "translate(5006 21296)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_77",
    "data-name": "Union 77",
    d: "M1.963,16.611A6.264,6.264,0,0,1,0,12.078V8.825A2.01,2.01,0,0,1,.444,7.56a2.2,2.2,0,0,1,1.163-.74V4.874A4.828,4.828,0,0,1,4.156.655a5.288,5.288,0,0,1,5.1,0A4.831,4.831,0,0,1,11.8,4.874V6.83a2.15,2.15,0,0,1,1.159.736,2.014,2.014,0,0,1,.448,1.259v3.253a6.264,6.264,0,0,1-1.963,4.533,6.927,6.927,0,0,1-9.485,0ZM1.6,7.765a1.206,1.206,0,0,0-.5.437,1.126,1.126,0,0,0-.187.624v3.253a5.41,5.41,0,0,0,1.7,3.916,5.98,5.98,0,0,0,8.188,0,5.41,5.41,0,0,0,1.7-3.916V8.825a1.179,1.179,0,0,0-.187-.628,1.323,1.323,0,0,0-1.064-.567H2.157A1.215,1.215,0,0,0,1.6,7.765ZM5.576,4.105a1.439,1.439,0,0,0-.43,1.1V6.756H8.262V5.2a1.438,1.438,0,0,0-.43-1.1,1.608,1.608,0,0,0-2.256,0ZM3.75,2.051A3.935,3.935,0,0,0,2.52,4.874V6.756H4.23V5.2a2.313,2.313,0,0,1,.694-1.728,2.553,2.553,0,0,1,3.56,0A2.3,2.3,0,0,1,9.178,5.2V6.749h1.713V4.874a3.935,3.935,0,0,0-1.23-2.823,4.318,4.318,0,0,0-5.911,0ZM6.031,14.82a.931.931,0,0,1-.642-.246l-1.6-1.513a.839.839,0,0,1,0-1.223.956.956,0,0,1,1.283,0l.948.905,2.6-2.491a.951.951,0,0,1,1.293,0v-.015a.885.885,0,0,1,.268.624.87.87,0,0,1-.268.62L6.69,14.574a.936.936,0,0,1-.633.247Z",
    transform: "translate(5011 21299)",
    fill: "#15355c"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.13985ad134dddbf813dbe77284a8219a.svg";
export { ForwardRef as ReactComponent };